import { render, staticRenderFns } from "./UserNavTabs.vue?vue&type=template&id=4f634dc5&scoped=true&"
var script = {}
import style0 from "./UserNavTabs.vue?vue&type=style&index=0&id=4f634dc5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f634dc5",
  null
  
)

export default component.exports